export enum editAction {
  RightMenu_SetItemProperty = 'RightMenu_SetItemProperty',

  EditAction_EditItem = 'EditAction_EditItem',

  EditAction_CreateNewItem = 'EditAction_CreateNewItem',
  EditAction_CreateResourcesFolder = 'EditAction_CreateResourcesFolder',
  EditAction_CreateNewContentItem = 'EditAction_CreateNewContentItem',

  EditAction_Reorder = 'EditAction_Reorder',
  EditAction_DeleteContentItem = 'EditAction_DeleteContentItem',
  EditAction_DeleteItem = 'EditAction_DeleteItem',

  EditAction_CopyItemUnderMenu = 'EditAction_CopyItemUnderMenu',
  EditAction_UpdateItem = 'EditAction_UpdateItem',
}
